const areas = {
  headerButtons: {
    create: {
      createBtn: 'הוסף',
    },

    import: 'ייבא',
  },
  table: {
    headers: {
      name: 'שם',
      type: 'סוג',
    },
    actions: {
      delete: 'מחק',
      export: 'ייצא',
    },
    toolTip: {
      noPermission: 'Action not allowed: Permission required',
    },
  },
  toast: {
    error: {
      badResponse: '[איזורים] תגובת שרת שגויה',
      create: {},
      edit: {},
      delete: '[איזורים] לא ניתן למחוק',
    },
    success: {
      create: {
        default: 'אזור נוצר בהצלחה',
      },
      edit: {},
      delete: {
        default: 'אזורים נמחקו בהצלחה',
      },
    },
  },
  create: {
    createBtn: 'חדש',
    successToast: {
      message: 'הצלחה! אזור נוצר',
    },
    errorToast: {
      message: 'אירעה שגיאה! לא ניתן ליצור אזור',
      duplicateMessage: 'קיים אזור עם השם שנבחר',
    },
    validations: {
      name: 'שם נדרש',
      type: 'סוג נדרש',
      siteId: 'מזהה אתר נדרש',
    },
  },
  delete: {
    deleteBtn: 'מחק',
    deleteModal: {
      header: 'מחק אזורים?',
      body: 'אתה עומד למחוק {{number}} אזורים',
    },
    successToast: {
      message: 'נמחק בהצלחה!',
    },
    errorToast: {
      message: 'אירעה שגיאה! לא ניתן למחוק אזור',
    },
  },
  update: {
    successToast: {
      message: 'הצלחה! אזור עודכן',
    },
    errorToast: {
      message: 'אירעה שגיאה! לא ניתן לעדכן אזור',
    },
    validations: {
      name: 'שם נדרש',
      type: 'סוג נדרש',
    },
  },
  forms: {
    tabs: {
      general: 'כללי',
      advancedSettings: 'הגדרות מתקדמות',
    },

    header: {
      createArea: {
        title: 'הוסף',
      },

      updateArea: {
        title: 'עדכן',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'שמור',
        update: 'שמור',
      },
    },

    information: {
      details: {
        header: 'פרטים',
        fields: {
          showOtherAreas: 'הצג אזורים אחרים',
          name: 'שם',
          type: 'סוג',
        },
      },
      map: {
        header: 'מפה',
      },
      settings: {
        btnAdd: 'הוסף',
        header: 'יחס',
        label: 'בחר אזורי יחס',
        notice: 'יחסים המכילים \'הכל\' משויכים וניתנים לעריכה בכל האזורים.',
        headerAreaRestrictions: 'הגבלות אזור',
        titleAreaRestrictions: 'חסימת פעולות',
      },
      advancedSettings: {
        consistentPassengerRouting: {
          title: 'ניתוב נוסעים עקבי',
          toolTipInformation:
            'מבטיח שקבוצת הנוסעים תיסע תמיד באותו מסלול אל האזור וממנו, לשיפור היעילות ולהפחתת בלבול.',
        },
        sameDriverForGroup: {
          title: 'אותו נהג לקבוצה',
          toolTipInformation:
            'מקצה את אותו נהג להסעת קבוצת הנוסעים גם לאיסוף וגם להורדה, לצורך היכרות ועקביות.',
        },
        overrideOptions: {
          bySystemSettings: 'לפי הגדרות המערכת',
          enabled: 'מופעל',
          disabled: 'מושבת',
        },
        tripBoardingTime: {
          title: 'זמן עלייה',
          toolTipInformation: 'הזמן שנדרש לאיסוף נוסע בתחנה שלו (פרמטר זה ישפיע על משך הנסיעה הכולל)',
        },
        waitForBoardingTime: {
          title: 'זמן המתנה לעלייה',
          toolTipInformation: 'בעת הגעה לתחנה, הנהג ימתין עד לשעת האיסוף המדויקת במידת הצורך.',
        },
        tripDropOffTime: {
          title: 'זמן ירידה',
          toolTipInformation: 'הזמן שנדרש להוריד נוסע בתחנה שלו (פרמטר זה ישפיע על משך הנסיעה הכולל)',
        },
        maxDropOffEarly: {
          title: 'מקסימום הגעה מוקדמת לירידה',
          toolTipInformation: 'מספר הדקות המרבי שבו נהג יכול להגיע מוקדם ביחס לשעת הירידה שנקבעה בהזמנה',
        },
        maxDropOffDelay: {
          title: 'מקסימום איחור בירידה',
          toolTipInformation: 'מספר הדקות המרבי שבו נהג יכול לאחר ביחס לשעת הירידה שנקבעה בהזמנה',
        },
        maxBoardingDelay: {
          title: 'מקסימום איחור לעלייה',
          toolTipInformation: 'מספר הדקות המרבי שבו נהג יכול לאחר ביחס לשעת האיסוף שנקבעה בהזמנה',
        },
        maxBoardingEarly: {
          title: 'מקסימום הגעה מוקדמת לעלייה',
          toolTipInformation: 'מספר הדקות המרבי שבו נהג יכול להגיע מוקדם ביחס לשעת האיסוף שנקבעה בהזמנה',
        },
        maxTripDuration: {
          title: 'מקסימום משך נסיעה',
          toolTipInformation: 'משך זמן מרבי של נסיעה בדקות',
        },
        maxSinglePassengerTime: {
          title: 'מקסימום משך נסיעה לנוסע יחיד',
          toolTipInformation: 'משך זמן מרבי של נסיעה בדקות לכל נוסע',
        },
      },
    },
  },

  polygoneTypes: {
    operationalArea: 'אזור תפעולי',
    fares: 'דמי נסיעה',
    routes: 'מסלולים',
    block: 'חסום',
  },
};

export default areas;
